module.exports = __webpack_public_path__ + "static/media/android.aa2b42c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/uq-ui/components/store-button/img/android.png
// module id = 1116
// module chunks = 0